<template>
  <el-table
    id="el-table"
    ref="table"
    v-loading="loading"
    class="dynamicTable tHeadNone"
    :data="tableData"
    :row-class-name="tableRowClassName"
    :cell-class-name="tableCellClassName"
    :stripe="false"
    :border="border"
    @cell-click="rowClick"
    @selection-change="handleSelectionChange"
    :row-key="'id'"
    :span-method="objectSpanMethod"
    height="100%"
  >
    <el-table-column>
    </el-table-column>
  </el-table>
</template>

<script>
import elTableInfiniteScroll from "el-table-infinite-scroll"; // 无限滚动加载
import { Table, TableColumn } from "element-ui";
export default {
  directives: {
    "el-table-infinite-scroll": elTableInfiniteScroll,
  },
  components: {
    "el-table": Table,
    "el-table-column": TableColumn,
  },
  props: {
    // 排序title
    paixu: {
      type: String,
      default: null,
    },
    // 是否支持多选
    isMultipleSelection: {
      type: Boolean,
      default: false,
    },
    // 表格的数据
    tableData: {
      type: Array,
      required: true,
    },
    // 多级表头的数据
    tableHeader: {
      type: [Array, Object],
      required: true,
    },
    height: {
      type: [String, Number, undefined],
      default: "",
    },
    // 行的 className 的回调方法
    tableRowClassName: {
      type: Function,
      default: null,
    },
    // 单元格的 className 的回调方法
    tableCellClassName: {
      type: Function,
      default: () => [],
    },
    // 是否带有纵向边框
    border: {
      type: Boolean,
      default: false,
    },
    // 是否带loading
    loading: {
      type: Boolean,
      default: false,
    },
    // 是否展示操作按钮
    isShowOpration: {
      type: Boolean,
      default: false,
    },
    // 操作按钮列表
    oprationBtnList: {
      type: Array,
      default: () => [],
    },
    // 是否可以行内点击
    isClick: {
      type: Boolean,
      default: false,
    },
    // 合并行或列
    objectSpanMethod: {
      type: [Function, undefined],
      default: undefined,
    },
    // 表格形式
    tableStyle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // 多选的数据
      multipleSelection: [],
    };
  },
  mounted() {
    this.tableGetMore();
  },
  methods: {
    /**
     * 上拉加载更多数据
     */
    tableGetMore() {
      const dom = document.querySelector(
        ".dynamicTable > .el-table__body-wrapper"
      );
      dom.addEventListener("scroll", () => {
        const scrollDistance =
          dom.scrollHeight - dom.scrollTop - dom.clientHeight - 10;

        if (scrollDistance <= 0) {
          this.$emit("loadScroll");
        }
      });
    },
    // 行内点击(单)
    rowClick(row, column) {
      if (this.isClick) {
        // 点击第一列
        if (column.property == "pageLabel") {
          // 自定义lightning页面 标签
          this.$emit("handleClick", row);
        } else if (column.property == "compUniName") {
          // 自定义lightning组件 组件名称
          this.$emit("handleClick", row);
        } else if (column.property == "label") {
          // 自定义传统页面  label
          this.$emit("handleClick", row);
          // 静态资源
          this.$emit("handleClickName", row);
        } else if (column.property == "name") {
          // 类/定时类/触发器  name
          this.$emit("handleClick", row);
        } else if (column.property == "filename") {
          // 静态资源列表  filename
          this.$emit("handleClick", row);
        } else if (column.property == "scriptName") {
          // 客户端脚本
          this.$emit("handleClickName", row);
        }
      } else {
        return;
      }
    },
    // 多选事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    /**工单操作按钮 */
    handleOpearBtn(params) {
      let { item2, scope } = params;
      this.$emit(item2.action, scope.row);
    },
  },
};
</script>
<style  lang="scss">
.dynamicTable {
  .copy {
    color: #409eff;
    cursor: pointer;
    margin-left: 8px;
  }
}
</style>
<style scoped>
.el-table td {
  vertical-align: top !important;
}
.el-table /deep/.el-table-column--selection .cell {
  padding-left: 10px;
}
.tHeadNone /deep/.has-gutter {
  display: none;
}
.el-descriptions {
  margin: 8px 0px;
}
</style>
